// extracted by mini-css-extract-plugin
export default {"logout":"index_logout__skX3k"};